import { useState, useEffect } from "react";
import { useLocation } from "react-router";
import { ReactComponent as BackIcon } from "../../assets/icons/arrow-left.svg";
import background from "../../assets/images/background.png";
import { DASHBOARD_ROUTE, HOME_ROUTE, SUPER_ADMIN_LOGIN_ROUTE } from "../../routes";
import { auth, isAuthenticated } from "../../services/firebase";
import OtpInput from "react-otp-input-rc-17";
import axios from "axios";
import qs from "qs";
import dataProvider from "../../services/dataProvider";
import authServices from "../../services/authServices";

const SuperAdminOTP = ({ history }) => {
    const [otp, setOtp] = useState("");
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const location = useLocation();

    useEffect(async () => {
        // console.log(location);
        if (!isAuthenticated()) {
            history.replace(SUPER_ADMIN_LOGIN_ROUTE);
        } else if (!location.state?.otpSent) {
            history.replace(SUPER_ADMIN_LOGIN_ROUTE);
        }
    }, []);

    function handleSubmit(e) {
        e.preventDefault();
        setIsLoading(true);
        var data = qs.stringify({ otp });
        // console.log("otp",data);
        var config = {
            method: "post",
            url: dataProvider.baseUrl + "verifyOtp",
            headers: {
                token: authServices.getToken(),
                "Content-Type": "application/x-www-form-urlencoded",
            },
            data: data,
        };

        axios(config)
            .then(function (response) {
                // console.log(response.data);
                if (response.data.status === "success") {
                    setIsLoading(false);
                    authServices.setaXNzdXBlcmFkbWlu(true);
                    history.replace(DASHBOARD_ROUTE);
                } else {
                    setIsLoading(false);
                    console.error(response.data);
                    setError(response.data.msg);
                }
            })
            .catch(function (error) {
                setIsLoading(false);
                console.error(error);
                setError(error.message);
            });
    }

    return (
        <div
            id="login-page"
            style={{
                backgroundImage: `url(${background})`,
                minHeight: "100vh",
            }}
        >
            <div className="container pb-5">
                <div className="btn mt-3">
                    <BackIcon
                        width="32"
                        onClick={() => {
                            history.replace(HOME_ROUTE);
                        }}
                    />
                </div>
                <h1 className="text-center text-light mt-5">Enter OTP</h1>
                <div className="container-fluid mt-5">
                    {error !== "" && (
                        <div style={{ maxWidth: "32rem" }} className="alert alert-danger mx-auto my-4" role="alert">
                            {error}
                        </div>
                    )}
                    <form className="mx-auto" style={{ maxWidth: "32rem" }} onSubmit={handleSubmit}>
                        <div className="text-light text-center">OTP has been sent to your email</div>
                        <div className="d-flex justify-content-center">
                            <OtpInput
                                value={otp}
                                onChange={setOtp}
                                numInputs={6}
                                inputStyle={{
                                    width: "3rem",
                                    height: "3rem",
                                    border: "2px solid #FFF3",
                                    borderRadius: "8px",
                                    backgroundColor: "transparent",
                                    color: "#fff",
                                    margin: "1rem",
                                }}
                            />
                        </div>
                        <div className="d-flex justify-content-center mt-5">
                            {isLoading ? (
                                <button
                                    style={{ height: "3rem" }}
                                    className="d-flex align-items-center btn btn-outline-light rounded-pill px-5 text-btn"
                                    disabled
                                >
                                    Verifying
                                    <div className="spinner-border ms-4" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </button>
                            ) : (
                                <button
                                    style={{ height: "3rem" }}
                                    className=" btn btn-outline-light rounded-pill px-5 text-btn"
                                >
                                    Verify
                                </button>
                            )}
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default SuperAdminOTP;
